// VerificationCoverage.js
import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Clock, AlertCircle } from 'lucide-react';

const VerificationCoverage = () => {
  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <motion.div 
          className="text-left mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-inter font-bold text-acBlack">
            Coverage & typical timelines
          </h2>
        </motion.div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Countries */}
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <div className="flex items-start mb-4">
              <div className="w-12 h-12 bg-acYellow rounded-full flex items-center justify-center flex-shrink-0">
                <Globe className="w-6 h-6 text-white" />
              </div>
            </div>
            <h3 className="text-xl font-inter font-bold text-acBlack mb-4">
              Countries
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Nigeria · Kenya · Ghana · Zimbabwe · South Africa
            </p>
          </motion.div>

          {/* Standard SLA */}
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="flex items-start mb-4">
              <div className="w-12 h-12 bg-acYellow rounded-full flex items-center justify-center flex-shrink-0">
                <Clock className="w-6 h-6 text-white" />
              </div>
            </div>
            <h3 className="text-xl font-inter font-bold text-acBlack mb-4">
              Standard SLA
            </h3>
            <p className="text-gray-600 leading-relaxed mb-3">
              3–7 business days (institution-dependent)
            </p>
            <p className="text-gray-600 leading-relaxed">
              <span className="font-semibold">Rush SLA:</span> 24–72 hours (where partners cooperate)
            </p>
          </motion.div>

          {/* Note */}
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <div className="flex items-start mb-4">
              <div className="w-12 h-12 bg-acYellow rounded-full flex items-center justify-center flex-shrink-0">
                <AlertCircle className="w-6 h-6 text-white" />
              </div>
            </div>
            <h3 className="text-xl font-inter font-bold text-acBlack mb-4">
              Important Note
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Some registrars respond only on specific days. We confirm realistic timelines at intake.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default VerificationCoverage;
